import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { Loading } from "@website/ui/loading";
import { numberConvert } from "@website/utils/number-convert";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
import { Header } from "@website/widget/login/components";
import { usePasswordCard } from "@website/widget/login/components/password-card/password-card.hook";
import styles from "@website/widget/login/components/password-card/password-card.module.scss";
import { PasswordCardPropertiesType } from "@website/widget/login/components/password-card/password-card.types";
import { PasswordField } from "@website/widget/password-field";
import { FC } from "react";

export const PasswordCard: FC<PasswordCardPropertiesType> = (properties) => {
  const { onClose } = properties;
  const {
    error,
    password,
    onChangePassword,
    onSubmitPassword,
    onOtpClick,
    isLoadingPassword,
    isLoadingOtp,
    onClickForgotPassword,
    onBackClick
  } = usePasswordCard(properties);

  return (
    <div className={styles["container"]}>
      <Header
        onBack={onBackClick}
        onClose={onClose}
        title="وارد کردن رمز عبور"
      />
      <form
        className="w-full"
        onSubmit={
          isLoadingPassword || isLoadingOtp ? undefined : onSubmitPassword
        }
      >
        <div className={styles["title"]}>لطفا رمز عبور خود را وارد کنید.</div>
        <div className={styles["input"]}>
          <PasswordField
            error={Boolean(error)}
            fullWidth
            helperText={error}
            hideConditions
            initialValue={password}
            onChange={onChangePassword}
            placeholder="رمز عبور"
          />
        </div>
        <div className={styles["info"]}>
          رمز عبور خود را فراموش کرده ام.
          <Button
            color="secondary"
            onClick={onClickForgotPassword}
            size="small"
            type="button"
            variant="text"
          >
            بازیابی رمز عبور
          </Button>
        </div>
        <div className={styles["footer"]}>
          <Button
            color="secondary"
            disabled={isLoadingOtp}
            fullWidth
            size="large"
            type="submit"
            variant="contained"
          >
            {isLoadingPassword ? (
              <Loading color="white" size="lg" />
            ) : (
              replaceSnappTripBasedOnChannel("تایید و ورود به اسنپ‌تریپ!")
            )}
          </Button>
          <Button
            color="secondary"
            disabled={isLoadingPassword}
            fullWidth
            onClick={isLoadingOtp || isLoadingPassword ? undefined : onOtpClick}
            size="large"
            type="button"
            variant="outline"
          >
            {isLoadingOtp ? (
              <Loading color="secondary" size="lg" />
            ) : (
              "ورود با کد یکبار مصرف"
            )}
          </Button>
          <Button
            StartIcon={<MaterialIcon name="support_agent" />}
            color="secondary"
            fullWidth
            href="tel:+982192000123"
            role="link"
            size="large"
            type="button"
            variant="text"
          >
            تماس با پشتیبانی ({numberConvert("02192000123", { locale: "fa" })})
          </Button>
        </div>
      </form>
    </div>
  );
};
